import { erpApi } from "@/shared/axios";
import { useMutation } from "@tanstack/react-query";
import { urlBackend } from '@/shared/constants/networking.constants';
import { getUrlParamsFetch } from "@/shared";

const { post, get, remove } = erpApi();


/**
 * Hook mutation para registrar la configuración de tránsito
 */
export const useCreateConfiguracionTransito = () => {
  return useMutation({
    mutationFn: async (params: any) => {
      const resp = await post<any[]>(
        `${urlBackend}api/v1/configuracion-transito/`,
        params,
        true
      );
      return resp;
    },
  });
};

export const useGetConfiguracionTransito = () => {
  return useMutation({
    mutationFn: async (params: any) => {
      const queryParams = getUrlParamsFetch(params || {});
      const resp = await get<any[]>(
        `${urlBackend}api/v1/configuracion-transito?${queryParams}`,
        params,
        true
      );
      return resp;
    },
  });
};

export const useDeleteConfiguracionTransito = () => {
  return useMutation({
    mutationFn: async (id: string) => {
      const resp = await remove(
        `${urlBackend}api/v1/configuracion-transito/${id}/`,
        true
      );
      return resp;
    },
  });
};
